import { render, staticRenderFns } from "./BarcodePrinting.vue?vue&type=template&id=56c4a4c4&"
import script from "./BarcodePrinting.vue?vue&type=script&lang=js&"
export * from "./BarcodePrinting.vue?vue&type=script&lang=js&"
import style0 from "./BarcodePrinting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports